import { Notification } from '@/modules/notification/models/Notification';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '@/modules/core/app/constants/ModelType';
import { camelizeKeys } from 'humps';

export class NotificationBroadcast extends BaseEntityModel {
  id?: number;

  type?: string;

  message?: string;

  isUndo?: boolean;

  notification?: Relationship<Notification | null>;

  constructor(model: Partial<NotificationBroadcast> = {}) {
    super(model);

    this.id = model.id;
    this.type = model.type;
    this.message = model.message;
    this.isUndo = model.isUndo;

    // @ts-ignore
    this.notification = Notification.mapModel(camelizeKeys(model.notification ?? {}));
  }

  getModelName(): ModelType {
    return ModelType.NOTIFICATION_BROADCAST;
  }
}
